// extracted by mini-css-extract-plugin
module.exports = {"success":"Wait_success__w4kcs","failure":"Wait_failure__23e70","feedback":"Wait_feedback__2E_8C","load":"Wait_load__6KK37"};